import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import { DRAWING_CONSTANTS } from "fond/constants";
import drawLineString from "fond/draw/modes/base/drawLineString";
import { isLineString } from "fond/types/geojson";

import { isValid } from "./helper";

const { constants: Constants } = MapboxDraw;

const drawLeadIns: DrawCustomMode = {
  ...drawLineString,

  onClick: function (state, e) {
    drawLineString.onClick?.call(this, state, e);

    // We restrict lead-ins to only 2 points.
    if (state.line.coordinates.length === 3) {
      // Prevent multiCreate from restarting draw mode for lead-ins
      state.preventMultiCreate = true;
      this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
    }
  },

  toDisplayFeatures: function (state, geojson, display) {
    if (geojson.type === "Feature" && state.line.id === geojson.properties?.id && geojson.properties && isLineString(geojson)) {
      geojson.properties.active = Constants.activeStates.ACTIVE;
      geojson.properties[`user_${DRAWING_CONSTANTS.Valid}`] = String(isValid(geojson, this.map));
      display(geojson);
    } else {
      display(geojson);
    }
  },
};

export default drawLeadIns;
